module.exports = __webpack_public_path__ + "static/media/learn-more-parent-image-1.0e538a95.jpg";